import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
import socket from './api/socket.js'
import lrz from 'lrz'
// import * as socketApi from './api/socket'
import '@/styles/index.scss' // global css
import '@/styles/common.scss' // global css
import axios from 'axios'
import directives from './directives.js'
import preventClick from './preventClick.js'
import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control
import { Swipe, SwipeItem } from 'vant';
Vue.use(Swipe);
Vue.use(SwipeItem);



Vue.prototype.jsonUrl = '../static/new_file.json';
import {
  localData,
  sessionData
} from "./utils/local.js"
import xYuanLocal from "./utils/xYuanLocal.js"
Vue.prototype.$axios = axios
Vue.prototype.socket = socket;
Vue.prototype.$localData = localData;
Vue.prototype.$sessionData = sessionData;
Vue.prototype.$xYuanLocal = xYuanLocal;

Vue.use(directives)
Vue.use(preventClick)
Vue.use(ElementUI, {
  locale
})

// 适配flex
import '@/common/flexible.js';
import dataV from '@jiaminghi/data-view'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(dataV)


// Vue.prototype.socketApi = socketApi
Vue.use(ElementUI, {
  locale
})
Vue.use(VCharts)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js